import { createMutation } from '@/mutations'
import { createPerson, deletePerson, patchPerson, updatePerson } from '@/features/profile/api/people'
import type { Person, PersonPatch, PersonPayload } from '@/types/people'

const PEOPLE_KEY = ['people']
const GIFT_RECIPIENTS_KEY = ['gift-recipients']

export const useCreatePersonMutation = () => {
  return createMutation<Person, PersonPayload>({
    mutationFn: (payload) => createPerson(payload),
    invalidateQueries: [PEOPLE_KEY, GIFT_RECIPIENTS_KEY],
  })
}

export const useUpdatePersonMutation = () => {
  return createMutation<Person, { id: number; payload: PersonPayload }>({
    mutationFn: ({ id, payload }) => updatePerson(id, payload),
    invalidateQueries: [PEOPLE_KEY, GIFT_RECIPIENTS_KEY],
  })
}

export const useDeletePersonMutation = () => {
  return createMutation<void, number>({
    mutationFn: (id) => deletePerson(id),
    invalidateQueries: [PEOPLE_KEY, GIFT_RECIPIENTS_KEY],
  })
}

/** BE-150 — `PATCH /user/gift-persons/{id}`: taste, budget, occasion or any field; `null` clears. */
export const usePatchPersonMutation = () => {
  return createMutation<Person, { id: number; patch: PersonPatch }>({
    mutationFn: ({ id, patch }) => patchPerson(id, patch),
    invalidateQueries: [PEOPLE_KEY, GIFT_RECIPIENTS_KEY],
  })
}
